import React from 'react';
import styles from './StudentActivityRow.module.css';
import { formatDate, hasNoActivityLaunchDate } from '../../utils/dateUtils';
import StudentDetailsCell from '../../../components/StudentDetailsCell/StudentDetailsCell';

import clsx from 'clsx';

const shouldShowWarning = (student, studentsWithoutActivity) => {
  const studentId = student.studentId || student.id;
  return (
    !student.launched_at ||
    studentsWithoutActivity.some((s) => (s.studentId || s.id) === studentId)
  );
};

const StudentActivityRow = ({
  student,
  studentsWithoutActivity,
  handleISGLaunch,
  setOpen,
}) => {
  return (
    <tr className={styles.studentRow}>
      <StudentDetailsCell
        studentId={student.studentId || student.id}
        firstName={student.first_name}
        lastName={student.last_name}
        email={student.email}
        showWarning={shouldShowWarning(student, studentsWithoutActivity)}
        handleISGLaunch={handleISGLaunch}
        setOpen={setOpen}
        nameTestId="inactive_alert_open_ISG_from_student_name"
      />
      <td
        className={clsx(styles.studentLastActivity, {
          [styles.noLastActivity]: hasNoActivityLaunchDate(student.launched_at),
        })}
        tabIndex={0}
      >
        {formatDate(student.launched_at)}
      </td>
    </tr>
  );
};

export default StudentActivityRow;
